import { createMutationHelper } from '@utils/swr'
import { type AxiosPromise } from 'axios'
import { type FortunePaymentExecutionRequest } from '../types/apiRequest'
import { type FortunePaymentExecutionResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'
import { fortunePaymentsQueue } from './fortunePaymentsQueue'

const { useMutation } = createMutationHelper<FortuneApis['post']['paymentExecution'], FortunePaymentExecutionResponse, FortunePaymentExecutionRequest>({
  client: 'fortune',
  key: '/payment/execution',
  fetcher: (url, { arg, client }) => fortunePaymentsQueue.add(
    () => client.post(url, arg)) as AxiosPromise<FortunePaymentExecutionResponse>,
})

export const useApiFpPaymentExecution = useMutation
